import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectFinancialStatus: "selectFinancialStatus [Action]",
  selectFinancialStatusLoading: "selectFinancialStatusLoading [Action]",
  selectFinancialStatusAsync: "selectFinancialStatusAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_financial_status_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectFinancialStatus:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectFinancialStatusLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectFinancialStatusLoading, payload: true });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "accounting",
    method_type: "select_financial_status",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectFinancialStatus,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectFinancialStatusLoading,
      payload: false,
    });
  }
}

export function* selectFinancialStatusBasket() {
  yield takeLatest(actionTypes.selectFinancialStatusAsync, handleWorker);
}
